<template>
    <div class="max-w-sm gap-1.5 grid w-full items-center">
        <Label class="gap-1 flex items-center" for="domain"
            >{{ $t("teams.member_role") }}
            <!-- <CircleHelp :size="16" class="text-iron-500" /> -->
        </Label>

        <Select v-model="model">
            <SelectTrigger>
                <SelectValue placeholder="Zvolte týmovou roli" />
            </SelectTrigger>
            <SelectContent>
                <SelectGroup>
                    <SelectItem value="admin">
                        {{ $t("teams.roles.admin.title") }}
                    </SelectItem>
                    <SelectItem value="editor">
                        {{ $t("teams.roles.editor.title") }}
                    </SelectItem>
                </SelectGroup>
            </SelectContent>
        </Select>
    </div>
</template>

<script lang="ts" setup>
import { Label } from "@/components/ui/label";
import {
    Select,
    SelectContent,
    SelectGroup,
    SelectItem,
    SelectTrigger,
    SelectValue,
} from "@/components/ui/select";

import { CircleHelp } from "lucide-vue-next";
const model = defineModel<string>();
</script>
